import autocollector from './autocollector';
import modern from './modern';
import dracula from './dracula';

export default {
  autocollector,
  modern,
  dracula,
};